import { sendHttp } from '../assets/js/request'

const userManageApi = {
  // 获取用户列表信息
  getUserList: params => {
    return sendHttp('get', '/system/sysPatient/listGlucoseCDSS', params)
  },
  // 获取用户详情
  getUserDetail: params => {
    return sendHttp('get', '/system/sysPatient/view', params)
  },
  // 保存用户信息
  saveUser: params => {
    return sendHttp('post', '/system/sysPatient/editBase', params)
  },
  // 获取血糖数据
  getBloodGlucoseData: params => {
    return sendHttp('get', '/system/sysBloodGlucose/list', params)
  },
  // 获取血糖报告数据
  getBloodGlucoseReportData: params => {
    return sendHttp('get', '/system/sysBloodGlucose/report', params)
  },
  // 获取图谱分析数据
  getAtlasAnalysisData: params => {
    return sendHttp('get', '/system/sysBloodGlucose/gluAtlas', params)
  },
  // 获取监测方案数据
  getMonitorSchemeData: params => {
    return sendHttp('get', '/system/sysPatient/monitorPlan', params)
  },
  // 获取监测情况数据
  getMonitorSituationData: params => {
    return sendHttp('get', '/system/sysPatient/monitorDetail', params)
  },
  // 获取血脂数据
  getBloodFatData: params => {
    return sendHttp('get', '/system/bloodFat', params)
  },
  // 获取HbA1c数据
  getHbA1cData: params => {
    return sendHttp('get', '/system/hba1c/list', params)
  }
}

export { userManageApi }



// WEBPACK FOOTER //
// ./src/apis/userManageApi.js